import React, { useState, useEffect } from 'react';
import Select from '../common/Select';
import axios from '../../axios/axiosconf';

const SelectorProfesionalAsignado = ({ 
    value, 
    onChange, 
    error, 
    required = false,
    placeholder = "Seleccione profesional...",
    showLabel = true
}) => {
    const [profesionales, setProfesionales] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const cargarProfesionales = async () => {
            try {
                const userdata = JSON.parse(localStorage.getItem('userdata'));
                if (!userdata) return;

                const config = {
                    headers: {
                        Authorization: 'Bearer ' + userdata.access_token
                    }
                };

                const response = await axios.get('/profesionales-historias', config);
                setProfesionales(response.data);
            } catch (error) {
                console.error('Error cargando profesionales:', error);
                setProfesionales([]);
            } finally {
                setLoading(false);
            }
        };

        cargarProfesionales();
    }, []);

    // Transformar profesionales para el formato del Select
    const opcionesProfesionales = profesionales.map(profesional => ({
        value: profesional.id,
        label: profesional.nombre
    }));

    // Agregar opción vacía si no es requerido
    const opciones = required 
        ? opcionesProfesionales
        : [{ value: '', label: 'Sin asignar' }, ...opcionesProfesionales];

    if (loading) {
        return (
            <div className="form-group">
                {showLabel && (
                    <label htmlFor="profesionalAsignado">
                        Profesional Asignado {required && <span className="text-danger">*</span>}
                    </label>
                )}
                <div className="form-control" style={{ color: '#6c757d' }}>
                    Cargando profesionales...
                </div>
            </div>
        );
    }

    return (
        <div className="form-group">
            {showLabel && (
                <label htmlFor="profesionalAsignado">
                    Profesional Asignado {required && <span className="text-danger">*</span>}
                </label>
            )}
            <Select
                options={opciones}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                isSearchable={true}
                customStyles={{
                    control: (provided, state) => ({
                        ...provided,
                        borderColor: error ? '#dc3545' : provided.borderColor,
                        '&:hover': {
                            borderColor: error ? '#dc3545' : provided.borderColor,
                        },
                    }),
                    menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                    }),
                }}
                menuPortalTarget={document.body}
            />
            {error && (
                <div className="invalid-feedback visible">
                    {error}
                </div>
            )}
            <small className="text-muted">
             
            </small>
        </div>
    );
};

export default SelectorProfesionalAsignado;